
/**
 * The iframe signing and proxying class
 *
 * It's assumed that the tools are embedded as an iframe in an LMS that
 * has the signing and proxy endpoints. Therefor the data is requested
 * from the parent window
 *
 * @class
 * @implements {ExampleInterface}
 * @see ally.js#addEventListener
 */
export function IframeRestApi() {}

/**
 * @see ExampleInterface.prototype.http
 */
IframeRestApi.prototype.http = function(method, path, parameters, opts, callback) {
    this._send('http', method, path, parameters, opts, callback);
};

/**
 * @see ExampleInterface.prototype.sign
 */
IframeRestApi.prototype.sign = function(method, path, parameters, callback) {
    this._send('sign', method, path, parameters, null, callback);
};

/**
 * @see ExampleInterface.prototype.getDownloadUrl
 */
IframeRestApi.prototype.getDownloadUrl = function(fileId, callback) {
    this._send('getDownloadUrl', null, null, { 'fileId': fileId }, null, callback);
};

/**
 * Send a message to the parent window using the browser's `postMessage` API
 *
 * @param  {String}     name                The subject of the message that should be posted
 * @param  {String}     method              The HTTP method ("GET" or "POST")
 * @param  {String}     path                The path on the Ally API
 * @param  {Object}     parameters          The parameters to send along
 * @param  {Object}     [opts]              The optional arguments to send alng
 * @param  {Function}   callback            Invoked when a response to this message is received
 * @param  {Object}     callback.err        An error object, if any
 * @param  {Object}     callback.response   The response of the listener in the parent window
 * @api private
 */
IframeRestApi.prototype._send = function(name, method, path, parameters, opts, callback) {
    var sentMessage = {
        'subject': name,
        'id': `iframe-api-${ Math.floor(Math.random() * 1000000)}`,
        'data': {
            'method': method,
            'path': path,
            'parameters': parameters,
            'opts': opts
        }
    };

    var listener = function(ev) {
        var receivedMessage = parseMessage(ev);
        if (receivedMessage && receivedMessage.responseTo === sentMessage.id) {
            window.removeEventListener('message', listener);
            return callback(receivedMessage.data.err, receivedMessage.data.response);
        }
    };

    window.addEventListener('message', listener);

    window.parent.postMessage(JSON.stringify(sentMessage), '*');
};

/* Generic helpers */

/**
 * Parse a window message event
 *
 * @param  {Object}         ev              Message event
 * @param  {Object}         ev.data         The data that has been sent with the message event
 */
var parseMessage = function(ev) {
    // Parse the provided event message
    if (ev && ev.data) {
        var message;
        try {
            message = JSON.parse(ev.data);
            return message;
        } catch (err) {
            return null;
        }
    } else {
        return null;
    }
};
